import { render, staticRenderFns } from "./UnlockedInstructions.vue?vue&type=template&id=64afa73a&"
import script from "./UnlockedInstructions.vue?vue&type=script&lang=js&"
export * from "./UnlockedInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports